<template>
  <li
    :class="{'active' : active}"
    class="price-item">
    <div
      :class="[
        {'active' : active},
        `price-item-rule-${indexKey}`
      ]">
      <div
        class="clearfix price-item-box"
        :class="{'active' : active}">
        <i
          class="fa fa-suitcase ico-suitcase"
          :class="{ 'ico-disabled': price.baggage_included }"></i>
          <span style="font-size: 12px"> x{{ price.baggage_pieces }} </span>
        <!-- Price Detail // FARE RULES -->
        <price-detail
          :index="price.id"
          :links="price.links"
          :carrier="carrier"></price-detail>
        <!-- // Price Detail // FARE RULES -->

        {{ price_name }}

        <button
          @click="$emit('handlePrices', price)"
          :class="{'active' : active}"
          :disabled="disabled"
          :title="disabled ? `A tarifa do voo de volta deve ser a mesma do voo de ida`:''"
          class="price-item-trigger pull-right"
          type="button">
          Selecionar<template v-if="disabled">*</template>
        </button>

        <strong
          v-if="!hideValue"
          class="pull-right"
          :class="{'price-item-disabled' : disabled}">
          {{ price.base | brlPrice }}
        </strong>
      </div>
    </div>
  </li>
</template>

<script>
import PriceDetail from '@/views/flights/search/PriceDetail';

export default {
  components: {
    PriceDetail
  },
  props: [
    'price',
    'active',
    'indexKey',
    'disabled',
    'hideValue',
    'carrier'
  ],
  data(){
    return {
      price_name: null,
      subtitles: {
        'Premium Economy Plus': 'Premium Eco Plus',
        'Premium Economy Top': 'Premium Eco Top'
      }
    }
  },
  mounted(){
    const words_list = this.price.brand.name.split(' ');
    this.price_name = this.price.brand.name
    if(words_list.length == 3 && words_list[1] == 'Economy'){
      this.price_name = this.subtitles[this.price.brand.name]
    }
  }
};
</script>

<style lang="scss">
@import '@/scss/views/flights/search/PriceItem';
</style>
